export default __webpack_public_path__ + "static/media/expNavy.3e04cc04.svg";